import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { CustomTextField } from 'components';
import { useFormValidation } from 'services/hooks/useFormValidation';
import { CapTableFormProps, FormValueCapTable } from './CapTableForm.props';
import { classes, StyledGrid } from './CapTableForm.styles';


const constraints = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, message: 'must be at least 3 characters' },
  },
};

const CapTableForm = ({ defaultFormState: { values, errors, dbErrors }, onFormChange }: CapTableFormProps) => {
  const { formValidated, validateForm } = useFormValidation(constraints);
  const [formValues, setFormValues] = useState<FormValueCapTable>(values);

  useEffect(() => {
    validateForm(formValues);
  }, [validateForm, formValues]);

  useEffect(() => {
    onFormChange(formValidated);
  }, [onFormChange, formValidated]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  return (
    <StyledGrid container>
      <CustomTextField
        required
        fullWidth
        id="name"
        name="name"
        type="text"
        label="Name"
        className={classes.margin}
        value={formValues.name as string}
        onChange={handleChange}
        formErrors={errors}
        dbErrors={dbErrors}
      />
    </StyledGrid>
  );
};

export default CapTableForm;
